import { OrgId } from "@hex/common";

import {
  OrgGuideFileMP,
  OrgGuideFileVersionMP,
} from "../../../../org-guide-files-multiplayer";
import { MagicRulesFileSpInitFragment } from "../../queries/useInitMagicRulesFile.generated";
import { ContextWorkbenchEntity } from "../contextWorkbenchEntity";

export function getEntityForMagicRulesFile(
  magicRulesFile: MagicRulesFileSpInitFragment,
): ContextWorkbenchEntity.MagicRulesFile {
  return {
    type: ContextWorkbenchEntity.Type.MagicRulesFile,
    orgId: magicRulesFile.orgId,
    userId: magicRulesFile.userId,
    magicRulesFileId: magicRulesFile.id,
    fileContent: magicRulesFile.fileContent,
    filename: magicRulesFile.filename,
    sizeBytes: magicRulesFile.sizeBytes,
  };
}

export function getEntityForOrgGuideFile(
  orgId: OrgId,
  orgGuideFile: OrgGuideFileMP,
  orgGuideFileVersion: OrgGuideFileVersionMP,
): ContextWorkbenchEntity.OrgGuideFile {
  return {
    type: ContextWorkbenchEntity.Type.OrgGuideFile,
    orgId,
    orgGuideFileId: orgGuideFile.id,
    orgGuideFileVersionId: orgGuideFileVersion.id,
    filePath: orgGuideFile.filePath,
    contents: orgGuideFileVersion.contentsText,
  };
}
